import { render, staticRenderFns } from "./FarmNotice.vue?vue&type=template&id=fee0dbc2&"
import script from "./FarmNotice.vue?vue&type=script&lang=js&"
export * from "./FarmNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports